import React from 'react'
import Style from './searchHistory.less'
import { _, UtilDevice } from '@iskytrip/sdk'
// import DomUtil from '../../utils/dom'
import { QueryLikeFlightCityList, QueryLikeAllCityList } from '@api'
import BaseComponent from '../../../base/BaseComponent'
import { Inputer } from '../../../components'
import propTypes from 'prop-types'

import BACK_PNG from '@assets/components/back.png'
import SEARCH_PNG from '@assets/components/search.png'

class SearchHistory extends BaseComponent {
	static propTypes = {
		isFullScreen: propTypes.bool,
	}

	static defaultProps = {
		isFullScreen: true,
	}

	constructor(props) {
		super(props)
		const { isAirprotCar } = this.props
		this.state = {
			flag: false,
			showHistory: true,
			showResult: false,
			history: [],
			result: [],
			signalBarHeight: 0,
			isAirportCar: isAirprotCar || false,
			isCityselectsearchinputFocus: false,
		}
		this.historyList = []
		this.pageHeight = 0
		this.cityselectsearchinput = React.createRef()
		this._bindSearch = _.debounce(100, this.querySearch.bind(this))
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps.isAirportCar !== prevState.isAirportCar) {
			return {
				...prevState,
				isAirportCar: nextProps.isAirportCar,
			}
		} else {
			return prevState
		}
	}

	componentDidMount() {
		if (this.cityselectsearchinput.current) {
			// this.cityselectsearchinput.current.focus();
			this.setState({ isCityselectsearchinputFocus: true })
		}
		this.pageHeight = document.body.offsetHeight

		const data = null // DomUtil.getLocalStorage('search_History'); qj
		if (data) {
			this.historyList = JSON.parse(data)
			this.setState({
				history: JSON.parse(data),
			})
		}
	}

	/**
	 * @override
	 */
	getSignalBarHeight(height) {
		console.log(' - - - - - - - - - getSignalBarHeight - - - - - - - - ')
		this.setState({ signalBarHeight: height })
	}

	_cancelClick() {
		this.props.searchClick()
	}

	_showClearHistory() {
		this.setState({
			flag: true,
		})
	}

	_cancelClearHistory() {
		this.setState({
			flag: false,
		})
	}

	_clearHistory() {
		let that = this
		// DomUtil.remLocalStorage('search_History'); qj
		that.setState(
			{
				history: [],
				flag: false,
			},
			() => {
				that.getHistory([])
			},
		)
	}

	getCityValue(list) {
		try {
			this.props.getCityValue(list)
		} catch (e) {
			console.log('暂无回调方法')
		}
	}

	_selectCity(item) {
		let cityId = item.cityId
		let name = item.name

		let value = { cityId: cityId, name: name, addressCode: 0, address: '' }

		this.historyList.forEach((v, index) => {
			if (+v.cityId === +cityId) {
				this.historyList.splice(index, 1)
			}
		})

		this.historyList.unshift(value)
		// DomUtil.setLocalStorage('search_History', JSON.stringify(this.historyList));
		this.getCityValue(value)
		this.getHistory(this.historyList)
		this.props.searchClick()
		this.props._showOrhide()
	}

	getHistory(list) {
		try {
			this.props.getHistory(list)
		} catch (e) {
			console.log('暂无回调方法')
		}
	}

	_selectCityResult(item) {
		let cityId = item.cityId
		let name = item.name
		let flag = 1
		const { isAirportCar } = this.state

		let value = { ...item, cityId, name, addressCode: 0, address: '' }
		if (isAirportCar) {
			value.adCode = item.adCode
			value.shortSpelling = item.shortSpelling
			value.spelling = item.spelling
		}

		if (this.historyList.length > 0) {
			this.historyList.forEach((v, index) => {
				if (+v.cityId === +cityId) {
					this.historyList.splice(index, 1)
					flag = 0
				}
			})

			if (!!flag === 0) {
				this.historyList.unshift(value)
			} else {
				if (this.historyList.length >= 4) {
					this.historyList.splice(3, 1)
					this.historyList.unshift(value)
				} else {
					this.historyList.unshift(value)
				}
			}
		} else {
			this.historyList.unshift(value)
		}

		// DomUtil.setLocalStorage('search_History', JSON.stringify(this.historyList)); qj
		this.getCityValue(value)
		this.getHistory(this.historyList)
		this.props.searchClick()
		this.props._showOrhide()
	}

	async querySearch(e) {
		let _this = this
		let value = this.cityselectsearchinput.current.value // = "";
		// let value = e.target.value;

		if (value) {
			_this.setState({
				showHistory: false,
				showResult: true,
			})

			if (!this.queryLikeFlightCityListModel) {
				if (this.props.isAllCity) {
					this.queryLikeFlightCityListModel = new QueryLikeAllCityList()
				} else {
					this.queryLikeFlightCityListModel = new QueryLikeFlightCityList()
				}
			}
			const res = await this.queryLikeFlightCityListModel.setParams(value).execute()
			_this.setState({
				result: res,
			})
		} else {
			_this.setState({
				showHistory: true,
				showResult: false,
			})
		}
	}

	_clearInput(e) {
		e.stopPropagation()
		this.cityselectsearchinput.current.value = ''
		this.setState({
			showHistory: true,
			showResult: false,
		})
	}

	HistoryList() {
		const { history } = this.state

		if (history.length === 0) {
			return <div className='hotHistory_box_none'>暂无历史搜索记录</div>
		} else {
			let list = history.map((item, index) => {
				return (
					<div
						className='search-history-list-ele'
						onClick={() => this._selectCity(item)}
						key={index}
					>
						{item.name}
					</div>
				)
			})

			return <div className='hotHistory_box'>{list}</div>
		}
	}

	searchResult() {
		const { result } = this.state

		if (!result.length) {
			return <div className='result_box_none'>未找到相应内容</div>
		} else {
			let list = result.map((item, index) => {
				return (
					<div
						className='result-list-ele'
						onClick={() => this._selectCityResult(item)}
						key={index}
					>
						<img alt='city-list-icon' src={SEARCH_PNG} className='city-list-icon' />
						<div className='city-list-cityname'>{item.name}</div>
						<div className='city-list-tag'>城市</div>
					</div>
				)
			})

			return <div className='result_box'>{list}</div>
		}
	}

	render() {
		const isFullScreen = this.props.isFullScreen
		const { flag, showResult, signalBarHeight, isCityselectsearchinputFocus } = this.state
		const isMiniApp = UtilDevice.isWxMini() || UtilDevice.isAlipayClient()

		return (
			<React.Fragment>
				<style dangerouslySetInnerHTML={{ __html: Style }} />
				<div className='component_search-history-con'>
					<div
						className='city-select-index'
						style={{
							// marginTop: isFullScreen ? `${signalBarHeight}px` : '0px',
							paddingTop: isFullScreen ? '0px' : '10px',
							top: isFullScreen ? '-44px' : '-54px',
						}}
					>
						<div
							className='search-history-sub-con'
							style={{ marginLeft: isMiniApp ? '0.48rem' : 0 }}
						>
							<div className='search-history-sub-con-l'>
								{!isMiniApp && (
									<img
										src={BACK_PNG}
										onClick={this._cancelClick.bind(this)}
										className='city-select-search-back'
										alt='back'
									/>
								)}
								<div className='city-select-search-input-con'>
									<img
										alt='search'
										src={SEARCH_PNG}
										className='city-select-search-input-search-logo'
									/>
									<div style={{ flex: 1, marginRight: '.24rem' }}>
										<Inputer
											ref={this.cityselectsearchinput}
											className='city-select-search-input'
											placeholder='搜索城市，如北京/beijing'
											onChange={this._bindSearch.bind(this)}
											isFocus={isCityselectsearchinputFocus}
											style={{
												height: '32px',
												lineHeight: '32px',
											}}
											inputStyle={{
												fontSize: '14px',
											}}
										/>
									</div>
								</div>
							</div>
							{/* <div onClick={this._cancelClick.bind(this)} className="city-select-cancel">取消</div> */}
						</div>
						{/* <div className="city-select-gradient"></div> */}
					</div>
					<div
						className='city-select-scroll'
						style={{
							marginTop: isFullScreen ? `${signalBarHeight + 44}px` : '54px',
							height: isFullScreen
								? this.pageHeight - signalBarHeight - 44
								: this.pageHeight - signalBarHeight - 154,
						}}
					>
						{/* {!!showHistory && <div className="search-history-content">
                            <div className="search-history-tip-con">
                                <div className="search-history-tip-con-l">历史搜索</div>
                                <img src={CLEAR_PNG} className="search-history-tip-con-r" onClick={this._showClearHistory.bind(this)} />
                            </div>
                            <div className="search-history-list">
                                {this.HistoryList()}
                            </div>
                        </div>} */}

						{!!showResult && <div className='search-result'>{this.searchResult()}</div>}
					</div>

					{!!flag && (
						<div className='dialog'>
							<div className='clearHistory'>
								<div className='text'>确定清除搜索历史？</div>
								<div className='bottom'>
									<div
										className='cancel'
										onClick={this._cancelClearHistory.bind(this)}
									>
										取消
									</div>
									<div
										className='clearNow'
										onClick={this._clearHistory.bind(this)}
									>
										清除
									</div>
								</div>
							</div>
						</div>
					)}
				</div>
			</React.Fragment>
		)
	}
}

export default SearchHistory
